import {
  HOME_SAVE_CLOSE_OUT_BEGIN,
  HOME_SAVE_CLOSE_OUT_SUCCESS,
  HOME_SAVE_CLOSE_OUT_FAILURE,
  HOME_SAVE_CLOSE_OUT_DISMISS_ERROR,
} from './constants';

import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveCloseOut(closeout,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_SAVE_CLOSE_OUT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/close_out';
      if(closeout.closeout === 0){
        URL+="/create";
      }else{
        URL+="/edit";
      }

      axios.post(URL, {
        close_out:closeout
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success === 1)
          {
            dispatch({
              type: HOME_SAVE_CLOSE_OUT_SUCCESS,
              data: res,
            });
            resolve(res);
          }else
          {
            dispatch({
              type: HOME_SAVE_CLOSE_OUT_FAILURE,
              data: { error: "Internal error" },
            });
            reject("Internal Error");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_SAVE_CLOSE_OUT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveCloseOutError() {
  return {
    type: HOME_SAVE_CLOSE_OUT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SAVE_CLOSE_OUT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveCloseOutPending: true,
        saveCloseOutError: null,
      };

    case HOME_SAVE_CLOSE_OUT_SUCCESS:
      // The request is success

      let fragmentContent = "The information has been saved with success!";
      let fragmentTitle = "Save Information";
      let paperTitle = "Save Information";
      return {
        ...state,
        savePending:false,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
        saveCloseOutPending: false,
        saveCloseOutError: null,
      };

    case HOME_SAVE_CLOSE_OUT_FAILURE:
      // The request is failed

      let fragmentContentFail = "We found an error";
      let fragmentTitleFail = "Save Information";
      let paperTitleFail = "Save Information";
      return {
        ...state,
        savePending:false,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
        saveCloseOutPending: false,
        saveCloseOutError: action.data.error,
      };

    case HOME_SAVE_CLOSE_OUT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveCloseOutError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/saveCloseOut.js